import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

const AdminBanner = () => {
    const router = useRouter();
    const [dataStore, setDataStore] = useState();
    useEffect(() => {
        const adminUser = sessionStorage.getItem("admin_login_as_user");
        setDataStore(adminUser);
    }, [router])

    if (dataStore) {
        return (
            <div style={{
                background: 'var(--site-purple)',
                color: '#fff',
                padding: '5px',
                textAlign: 'center',
                fontSize: "20px",
                fontWeight: 'bold',
                marginTop: '60px',
                display: 'block',
                float: 'left',
                width: '100%',
                position: 'fixed',
                float: 'left',
                zIndex: '999',
                bottom: '0'

            }}>

                You are logged in as {dataStore}

            </div>
        );
    }
    else {
        return (
            <></>
        )
    }

};

export default AdminBanner;
